import { render, staticRenderFns } from "./ElProductVariant.vue?vue&type=template&id=799122a3"
import script from "./ElProductVariant.vue?vue&type=script&lang=js"
export * from "./ElProductVariant.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports